import { createSelector } from "@reduxjs/toolkit";

export const selectDictionaries = (state) => state.dictionaries.dictionaryList;

export const selectEditDictionaryState = (state) => state.dictionaries.edit;

export const selectDictionary = createSelector(
  [selectEditDictionaryState],
  (edit) => edit.editDictionary
);

export const selectDictionaryName = createSelector(
  [selectDictionary],
  (dictionary) => dictionary?.name
);

export const selectDictionaryId = createSelector(
  [selectDictionary],
  (dictionary) => dictionary?.id
);

export const selectDictionaryLocked = createSelector(
  [selectDictionary],
  (dictionary) => Boolean(dictionary?.locked)
);

export const selectDictionaryOwner = createSelector(
  [selectDictionary],
  (dictionary) => {
    const { createdBy = "Unknown", createdDate } = dictionary || {};

    return [createdBy === "Unknown" ? "System" : createdBy, createdDate];
  }
);

export const selectDictionaryLastUpdated = createSelector(
  [selectDictionary],
  (dictionary) => {
    const { updatedBy, updatedDate } = dictionary || {};
    return [updatedBy, updatedDate];
  }
);

export const selectDictionaryCategories = createSelector(
  [selectDictionary],
  (dictionary) => dictionary?.categories || []
);

export const selectDictionaryDescription = (state) =>
  state.dictionaries?.edit?.editDictionary?.description;

export const selectCurrentDictionaryTypes = createSelector(
  [selectDictionary],
  (dictionary) => dictionary?.dictionaryTypes || []
);

export const selectTableSettings = createSelector(
  [selectEditDictionaryState],
  (edit) => edit?.tableSettings
);

export const selectIsEditMode = createSelector(
  [selectTableSettings],
  (tableSettings) => Boolean(tableSettings?.isEditMode)
);

export const selectSelectedRowIndex = createSelector(
  [selectTableSettings],
  (tableSettings) => tableSettings?.selectedRowIndex
);

export const selectSettings = (state) => state.dictionaries.edit.tableSettings;

export const selectWildcardPopup = createSelector(
  [selectSettings],
  (state) => state?.wildcardPopup
);

export const selectIsWildcardPopupVisible = createSelector(
  [selectWildcardPopup],
  (wildcardPopup) => Boolean(wildcardPopup?.displayed)
);

export const selectWildcardPopupTerm = createSelector(
  [selectWildcardPopup],
  (wildcardPopup) => wildcardPopup?.term
);
